import React from 'react';
import Post from '../Post/Post';

export default function Posts() {
  return <div>
      <Post/>
  </div>;
}
